import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/numerology-calculator/page.tsx");
